/*
Publicly available environment variables (almost all of them) are in environment.json.
Private environment variables (keys for internal tests, etc.) are in .env.
environment-local.json for local environments is in the root directory.
environment.json for upper environments is added during the build pipeline.
*/
let env;
let wasEnvFetched = false;

/**
 * Fetch env file (or return env if already fetched)
 */
export async function fetchEnv(): Promise<any> {
  if (wasEnvFetched) {
    return env;
  }

  env = await (await fetch('/environment.json')).json();
  wasEnvFetched = true;
  return env;
}

/**
 * Get current env config
 * @returns {*} The current env config
 */
export function getEnv(): any {
  if (!env) throw new Error('attempted to use env before fetched');

  return env;
}
